<button
	[id]="buttonId"
	class="btn btn--icon-secondary-hover"
	[disabled]="disabled"
	[ngClass]="{ 'btn--icon-paddings': isVerticalPaddings, 'btn--px-12': !isVerticalPaddings, 'btn--refresh-smaller': isSmaller }"
	(click)="refresh()">
	<i *ngIf="!refreshing" class="fas fa-sync"></i>
	<i *ngIf="refreshing" class="fas fa-sync fa-spin"></i>
</button>
